import React from 'react';
import ReactSkeleton from 'react-loading-skeleton';

const Skeleton = ({ hasError, ...props }) => (
    <ReactSkeleton duration={hasError ? 99999 : 1.2} {...props} />
);

export default Skeleton;



// WEBPACK FOOTER //
// ./src/components/Skeleton/Skeleton.jsx